import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

export class LogoList {
  container: String

  constructor(container: String) {
    ;(this.container = container), this.initSlider()
  }

  initSlider() {
    new Swiper(this.container, {
      autoplay: {
        delay: 3000,
      },
      loop: true,
      slidesPerView: 2,
      spaceBetween: 80,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 3,
        },
        1240: {
          slidesPerView: 3,
        },
      },
    })
  }
}
